import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';

import {MediaPlayer, MediaProvider} from '@vidstack/react';
import {defaultLayoutIcons, DefaultVideoLayout} from '@vidstack/react/player/layouts/default';
import {css} from "@emotion/css";

import "./VideoPlayer.scss"

export default function VideoPlayer(
    {
        url = "",
        file,
        name = "",
        className = ""
    }) {


    return (
        <div className={`baseVideoPlayer ${className}`}>
            <MediaPlayer
                title={name}
                src={file ? file : url}
            >
                <MediaProvider/>
                <DefaultVideoLayout
                    thumbnails=""
                    icons={defaultLayoutIcons}/>
            </MediaPlayer>
        </div>
    )
}